import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  template: `<div class="content-wrapper">
    <div class="container-fluid">
      <div class="content-header">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>`
})
export class MainComponent {}
